import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col, Button } from 'react-bootstrap';

const DefaultCardHeader = ({
    title,
    addButton,
    addAction
}) => {
    return (
        <Card.Header className="border-bottom border-200">
            <Row className="align-items-end g-2">
                <Col>
                    <h5 className="mb-0">
                        {title}
                    </h5>
                </Col>
                <Col xs={'auto'}>
                    {
                        addButton && (
                            <Button variant="primary" size="sm" onClick={addAction}>
                                Tambah Data
                            </Button>
                        )
                    }
                </Col>
            </Row>
        </Card.Header>
    );
}

const DefaultCardBody = ({
    children
}) => {
    return (
        <Card.Body >
            {children}
        </Card.Body>
    );
}

const DefaultCard = ({
    children
  }) => {
    return (
        <Card className="h-md-100">
            {children}
        </Card>
    );
}

DefaultCard.Header = DefaultCardHeader;
DefaultCard.Body = DefaultCardBody;

DefaultCard.propTypes = {};
DefaultCardHeader.propTypes = {
    title: PropTypes.string,
    addButton: PropTypes.bool
};

export default DefaultCard;